/**
 * Map a leftover in-app `/guides?guide=<slug>` URL onto the public grammar
 * library (`/learn/grammar`, Vercel-rewritten to /api/grammar).
 *
 * Anonymous visitors must leave the SPA with a full navigation so the
 * rewrite runs — React Router `<Navigate>` would 404 the catch-all instead
 * (issue #128). Slugs are constrained to the grammar-guide id shape so a
 * crafted `?guide=` cannot bounce the visitor to an arbitrary path.
 */
const GUIDE_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/i;

export function publicGrammarPath(search: string): string {
  const query = search.startsWith('?') ? search : search ? `?${search}` : '';
  const guide = new URLSearchParams(query).get('guide');
  if (guide && GUIDE_SLUG.test(guide)) {
    return `/learn/grammar/${guide}`;
  }
  return '/learn/grammar';
}
